<template>
    <div class="l-footer" v-show="isShowBottomTab">
        <div class="l-footer__page" @click="changeTabStatus('index')">
            <span class="icon" v-if="tabActive=='index'">
                <img src="../../../assets/app/home2.png" alt="">
            </span>
            <span class="icon" v-else>
                <img src="../../../assets/app/home1.png" alt="">
            </span>
            <span :class="['name', {'active': tabActive=='index'}]">首页</span>
        </div>
        <div class="l-footer__page" @click="changeTabStatus('add')">
            <span class="icon" v-if="tabActive=='add'">
                <img src="../../../assets/app/app2.png" alt="">
            </span>
            <span class="icon" v-else>
                <img src="../../../assets/app/app1.png" alt="">
            </span>
            <span :class="['name', {'active': tabActive=='add'}]">应用</span>
        </div>
        <div class="l-footer__page" @click="changeTabStatus('setMeal')">
            <span class="icon" v-if="tabActive=='setMeal'">
                <img src="../../../assets/app/star2.png" alt="">
            </span>
            <span class="icon" v-else>
                <img src="../../../assets/app/star1.png" alt="">
            </span>
            <span :class="['name', {'active': tabActive=='setMeal'}]">收藏</span>
        </div>
        <div class="l-footer__page" @click="changeTabStatus('add')">
            <span class="icon" v-if="tabActive=='add'">
                <img src="../../../assets/app/mine2.png" alt="">
            </span>
            <span class="icon" v-else>
                <img src="../../../assets/app/mine1.png" alt="">
            </span>
            <span :class="['name', {'active': tabActive=='add'}]">我的</span>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            // tabArray: ['index', 'add', 'addAreaDetails', 'addChannelDetails', 'setMealAreaDetails', 'setMealChannelDetails','setMeal'],
            tabArray: ["index", "add", "setMeal"]
        };
    },
    computed: {
        isShowBottomTab() {
            return this.$store.state.isShowBottomTab;
        },
        tabActive() {
            return this.$store.state.tabActive;
        }
    },
    methods: {
        changeTabStatus(pageName) {
            if (this.tabActive !== pageName) {
                this.$router.push(`/${pageName}`);
            }
        }
    },
    watch: {
        $route(to, from) {
            let path = to.path.split("/")[1];
            // console.log("path：", path);
            if (this.tabArray.includes(path)) {
                this.$store.commit("SET_PAGE_STATE_ROOT", {
                    tabActive: path
                });
            } else {
                this.$store.commit("SET_PAGE_STATE_ROOT", {
                    tabActive: ""
                });
            }
        }
    },
    mounted() {
        let tabActive = "";
        const tabArray = this.tabArray;
        let path = this.$route.path.split("/")[1];
        if (path && tabArray.includes(path)) {
            tabActive = path;
        }
        this.$store.commit("SET_PAGE_STATE_ROOT", {
            tabActive
        });
    }
}

</script>
<style lang="less" scoped>
.font-family-fn(@family) {
  font-family: @family;
}

.popups {
  position: absolute;
  z-index: 999999999;
  border-radius: 8px;
  padding: 10px;
  background: #fff;
  right: -0.2rem;
  top: .7rem;
  width: 3rem;
  text-align: center;
  font-weight: normal;
}

.popups-content {
  color: #666;
  font-size: 0.3rem;
}

.popups-top {
  display: inline-block;
  width: 0;
  height: 0;
  border: solid transparent;
  border-width: 10px;
  border-bottom-color: #fff;
  content: "";
  position: absolute;
  top: -0.35rem;
  right: .2rem;
  z-index: 999999999;
}

.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
  z-index: 99999999;
}

</style>



// WEBPACK FOOTER //
// src/components/app/common/tab.vue